export const firstPath = (link: string) => link.split('/')[1];
